<template>
  <div class="searchUser">
    <div class="searchUser__grid">
      <div>
        <label for="customer-email">Rechercher un client</label>
        <input id="customer-email" type="text" placeholder="email ou téléphone..." v-model="userEmailOrPhone" ref="email">
      </div>
      <div>
        <SvgSpinner v-show="userLoading" width="85"/>
      </div>
    </div>
    <transition-group name="fast" tag="ul">
      <li v-for="u in userSearchResults" :key="u.ID" :value="u.user_email">
        <a ref="selectCustomer" @click="selectCustomer(u.ID)">{{ u.user_email }}</a> <span
        v-if="u.hasOwnProperty('orderId')">#{{ u.orderId }}</span>
      </li>
    </transition-group>
  </div>
</template>

<script>
import SvgSpinner from "@/components/partials/SvgSpinner";

export default {
  name: "SearchUser",
  components: {SvgSpinner},
  data() {
    return {
      userEmailOrPhone: '',
      userSearchResults: [],
      userLoading: false,
      source: {},
    }
  },
  watch: {
    userEmailOrPhone(newVal) {
      if (newVal.length >= 6) {
        if (!this.userLoading) {
          this.searchCustomer()
        } else {
          this.cancelSearch()
          this.searchCustomer()
        }
      }
      if (this.$refs.email.checkValidity()) {
        this.$emit('email-valid', newVal);
      }
    },
  },
  methods: {
    searchCustomer() {
      const CancelToken = $api.CancelToken;
      this.source = CancelToken.source();
      // console.log('search')
      this.userLoading = true
      $api.get(`g2r/v1/customer/search?email=${this.userEmailOrPhone}`, {cancelToken: this.source.token})
        .then(response => response.data)
        .then(data => {
          // console.log('done');
          this.userSearchResults = data;
          this.userLoading = false;
        })
        .catch(() => '')
    },
    cancelSearch() {
      // cancel the request (the message parameter is optional)
      this.source.cancel('Abort');
    },
    selectCustomer(key) {
      this.userEmailOrPhone = ''
      this.$refs.email.placeholder = this.userSearchResults[key].user_email
      this.$emit('user-found', this.userSearchResults[key])
    },
  },
}
</script>

<style scoped lang="scss">

.searchUser {
  margin-bottom: 2rem;

  .searchUser__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 3%;

    div:nth-child(2) {
      justify-self: flex-start;
    }

    [type="text"] {
      margin-bottom: 2rem;
    }
  }
}

ul {
  li {
    a {
      cursor: pointer;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .6s ease-in-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fast-enter-active, .fast-leave-active {
  transition: all .2s ease-in-out;
}

.fast-enter, .fast-leave-to {
  opacity: 0;
  transform: translateX(440px);
}

.fast-enter-move {
  transition: transform .2s;
}
</style>
